import { impactCategoryConfig } from 'constants/impactCategoryConfig';
import React from 'react';
import styled from 'styled-components';
import { useBrowser } from 'hooks';
const ImpactClaimButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, active }) => active ? theme.palette.grey.A800 : '#fff'};
  box-shadow: ${({ theme, hasBoxShadow }) => hasBoxShadow ? theme.shadows[0] : 'unset'};
  color: ${({ active }) => (active ? '#fff' : '#000')};
  border-radius: 26px;
  padding: 10px 20px;
  white-space: nowrap;
  margin: 0 15px 15px 0;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.backgrounds.blueIce};
  transition: all 0.25s ease;

  ${({ isMobile, active, theme }) => !isMobile &&
    !active &&
    `
     &:hover {
        background: ${theme.palette.grey[50]};
      }
  `}

  ${({ fullWidth }) => fullWidth &&
    `
    width: calc(100% - 10px);
  `}

  ${({ renderedOnImpactSlider }) => renderedOnImpactSlider &&
    `
    &:last-child {
    margin-right: 50px;
    }
  `}

  div {
    max-width: 100%;
    display: flex;
    align-items: center;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  img {
    max-width: 100%;
  }
`;
const IconContainer = styled.div `
  width: 28px;
  height: 28px;
  margin-top: -3px;
  margin-bottom: -3px;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    border-radius: 50%;
    object-fit: contain;
  }
`;
const ImpactClaimTitle = ({ impactClaim, active = false, fullWidth = false, onClaimClick, hasBoxShadow = false, renderedOnImpactSlider = false, }) => {
    var _a;
    const FallbackIcon = (_a = impactCategoryConfig[impactClaim.impactCatalogItem.category.type]) === null || _a === void 0 ? void 0 : _a[active ? 'activeIcon' : 'icon'];
    const { isMobile } = useBrowser();
    const iconUrl = impactClaim.impactCatalogItem.iconUrl;
    return (React.createElement(ImpactClaimButton, { active: active, onClick: () => onClaimClick(impactClaim.id), fullWidth: fullWidth, hasBoxShadow: hasBoxShadow, renderedOnImpactSlider: renderedOnImpactSlider, id: "st-claims-button", isMobile: isMobile, "data-cy": "impact-claim-button" },
        React.createElement("div", null,
            React.createElement(IconContainer, null, iconUrl ? (React.createElement("img", { src: iconUrl, alt: "impact claim icon", "data-cy": "impact-claim-button-icon" })) : (React.createElement(FallbackIcon, { "data-cy": "impact-claim-button-icon" }))),
            React.createElement("span", null, impactClaim.impactCatalogItem.title))));
};
export default ImpactClaimTitle;
